var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgJobs28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1666 0.402466C9.50977 0.402466 8.16663 1.74561 8.16663 3.40247V11.2013C8.16663 12.8581 9.50977 14.2013 11.1666 14.2013H16.8333C18.4901 14.2013 19.8333 12.8581 19.8333 11.2013V3.40247C19.8333 1.74561 18.4901 0.402466 16.8333 0.402466H11.1666ZM11.5 2.91138C10.9477 2.91138 10.5 3.35909 10.5 3.91138V10.6924C10.5 11.2447 10.9477 11.6924 11.5 11.6924H16.5C17.0523 11.6924 17.5 11.2447 17.5 10.6924V3.91138C17.5 3.35909 17.0523 2.91138 16.5 2.91138H11.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.67468C1.34315 6.67468 0 8.01782 0 9.67468V14.9646C0 15.5913 0.192125 16.173 0.520684 16.6542C4.26001 17.1857 7.43076 17.5311 10.4386 17.6866V15.6392C10.4386 14.9765 10.9759 14.4392 11.6386 14.4392H15.9929C16.6556 14.4392 17.1929 14.9765 17.1929 15.6392V17.7103C20.311 17.5692 23.5869 17.2191 27.4784 16.6555C27.8075 16.174 28 15.5918 28 14.9646V9.67468C28 8.01783 26.6569 6.67468 25 6.67468H3ZM26.8333 18.2625C23.2372 18.7655 20.1474 19.0807 17.1929 19.2117V20.7917C17.1929 21.4545 16.6556 21.9917 15.9929 21.9917H11.6386C10.9759 21.9917 10.4386 21.4545 10.4386 20.7917V19.1885C7.59507 19.0443 4.61337 18.7334 1.16667 18.2592V25.0001C1.16667 26.6569 2.50981 28.0001 4.16666 28.0001H23.8333C25.4902 28.0001 26.8333 26.6569 26.8333 25.0001V18.2625ZM11.7897 19.2447V20.2183C11.7897 20.4392 11.9688 20.6183 12.1897 20.6183H15.4423C15.6632 20.6183 15.8423 20.4392 15.8423 20.2183V19.259C14.4869 19.2936 13.1484 19.2888 11.7897 19.2447ZM15.8423 17.7585V16.2121C15.8423 15.9912 15.6632 15.8121 15.4423 15.8121H12.1897C11.9688 15.8121 11.7897 15.9912 11.7897 16.2121V17.744C13.1489 17.7889 14.4868 17.7939 15.8423 17.7585Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.7894,
    y: 16.38,
    width: 4.05263,
    height: 4.35752,
    rx: 0.4,
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJobs28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;